import './FormBuilder.css';

import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import BodyHeader from "../Layouts/BodyHeader/BodyHeader";
import Navigation from '../Layouts/Navigation/navigation';
import { useContext, useEffect } from 'react';
import FormBuilderCartContext from './cart/formBuilderCartContext';
import NotificationBar from '../Layouts/Notification/notificationBar';
import useNotifications from '../../hooks/useNotifications';

export default function FormBuilder() {
  const { formBuilderCart, ...restCart } = useContext(FormBuilderCartContext);
  const { notifications, removeNotification, ...restNotifications } = useNotifications();

  let location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname.replaceAll('/', '').endsWith('form-builder')) {
      // add slight delay to give the formBuilderCart a chance to be populated from sessionStorage if needed
      setTimeout(() => {
        if (formBuilderCart.length)
          navigate('cart');
        else
          navigate('instructions');
      }, 50);
    }
  }, [location, navigate, formBuilderCart.length]);

  return (
    <>
      <BodyHeader pageHeader="Form Builder" />
      <Navigation>
        <NavLink to="instructions">Instructions</NavLink>
        <NavLink to="cart">Form Builder Cart</NavLink>
      </Navigation>
      <NotificationBar notifications={notifications} closeHandler={removeNotification} />
      <Outlet context={{
        cartContext: { formBuilderCart, ...restCart },
        notificationsContext: { ...restNotifications }
      }} />
    </>
  );
}
